import React, { useState } from "react";
import { baseUrl } from "../Services/Constants";
import axios from "axios";
import { processAndUpdateToken } from "../Services/CommonFunctions";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { DatePicker } from "@fluentui/react";
import { IconButton } from "office-ui-fabric-react/lib/Button";
import { IIconProps } from "office-ui-fabric-react/lib/Icon";
import { format } from "date-fns";

const NewReport = ({ activeTab , refresh, disabled, brokerId }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [msgVisible, setMsgVisible] = useState(false);
  const [msgClass, setMsgClass] = useState("");
  const [msgText, setMsgText] = useState("");
  const [token, setToken] = useState(sessionStorage.getItem("token"));

  const onDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "M/d/yyyy");
      setSelectedDate(formattedDate);
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const postApiCallForDatepicker = async (selectedDate) => {
    document.body.classList.add("loading-indicator");
    let Token = await processAndUpdateToken(token);

    const formattedDate = formatDate(selectedDate);

    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const apiUrl = `${baseUrl}/api/ProcedureData/grid-reports`;

    axios({
      method: "POST",
      url: apiUrl,
      headers: headers,
      data: {
        InputDate: formattedDate,
        Status: "Pending",
        UserName: sessionStorage.getItem("userName"),
      },
    })
      .then((response) => {
        if (response.status !== 201) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        refresh();
        setSelectedDate(null);
        return response.data;
      })
      .then((data) => {
        if (data?.status == 400) {
          setMsgVisible(true);
          setMsgClass("alert error");
          setTimeout(() => {
            setMsgVisible(false);
            setMsgText("");
          }, 3500);
        }
      })
      .finally(() => {
        document.body.classList.remove("loading-indicator");
      });
  };

  const postQuoteCompareReport = async (selectedDate) => {
  document.body.classList.add("loading-indicator");

  let Token = await processAndUpdateToken(token);
  const formattedDate = formatDate(selectedDate);

  const headers = {
    Authorization: `Bearer ${Token}`,
    "Content-Type": "application/json",
  };

  const apiUrl = `${baseUrl}/api/ProcedureData/quotecompare-reports`;

  const payload = {
    BrokerId:  brokerId || 0,
    UserName: sessionStorage.getItem("userName"),
    InputDate: formattedDate,
  };

  try {
    const response = await axios.post(apiUrl, payload, { headers });

    if (response.status !== 200 && response.status !== 201) {
      throw new Error("Failed to generate quote compare report");
    }

    refresh();
    setSelectedDate(null);
  } catch (error) {
    setMsgVisible(true);
    setMsgClass("alert error");
    setMsgText("Error generating quote compare report");

    setTimeout(() => {
      setMsgVisible(false);
      setMsgText("");
    }, 3500);
  } finally {
    document.body.classList.remove("loading-indicator");
  }
};

  const postAmsApiCallForDatepicker = async (selectedDate) => {
    document.body.classList.add("loading-indicator");
    let Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const apiUrl = `${baseUrl}/api/ProcedureData/grid-AddAMSreports`;

    axios({
      method: "POST",
      url: apiUrl,
      headers: headers,
      data: {
        InputDate: selectedDate,
        Status: "Pending",
        UserName: sessionStorage.getItem("userName"),
      },
    })
      .then((response) => {
        if (response.status !== 201) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        refresh();
        setSelectedDate(null);
        return response.data;
      })
      .then((data) => {
        if (data?.status == 400) {
          setMsgVisible(true);
          setMsgClass("alert error");
          setTimeout(() => {
            setMsgVisible(false);
            setMsgText("");
          }, 3500);
        }
      })
      .finally(() => {
        document.body.classList.remove("loading-indicator");
      });
  };

  const handleButtonClick = (selectedDate) => {
    if (activeTab === "table1") {
      postApiCallForDatepicker(selectedDate);
    }
    else if (activeTab === "table2") {
      postQuoteCompareReport(selectedDate);
    }
    //  else if (activeTab === "table4") {
    //   postAmsApiCallForDatepicker(selectedDate);
    // }
  };

  const refreshIcon = { iconName: "Refresh" };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <DatePicker
            style={{ width: "200px", margin: "13px 10px 9px 6px" }}
            placeholder="Select a date..."
            onSelectDate={onDateChange}
            disabled={disabled}
            // maxDate={activeTab === "table2" ? new Date() : undefined}
            maxDate={new Date()}
          />
          {selectedDate && (
            <PrimaryButton
              onClick={() => handleButtonClick(selectedDate)}
            >
              Generate
            </PrimaryButton>
          )}
        </div>
        <IconButton
          iconProps={refreshIcon}
          title="Refresh"
          ariaLabel="Refresh"
          onClick={() => {
            refresh();
          }}
          style={{
            color: "black",
            margin: "8px 20px 8px 20px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          }}
        />
      </div>
    </>
  );
};

export default NewReport;
